import {newRequest} from '@/utils/request'

// 密码登录
export const passwordLogin = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/user/login/password', params)

// 验证码登录
export const codeLogin = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/user/login/message', params)

// 获取验证码
export const sendCode = <T>(phone: string) => newRequest.post<Ajax.Response<T>>(`/authority/user/login/sendMessage?phone=${phone}`)

// 获取钉钉key
export const getKey = <T>() => newRequest.get<Ajax.Response<T>>('/authority/user/login/getKey')

// 钉钉登录
export const ddLogin = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/user/login/dingding', params)

// 退出登录
export const loginOut = <T>(token: string) => newRequest.get<Ajax.Response<T>>(`/authority/user/login/loginOut?token=${token}`)

// 检测是否需要验证码（返回布尔）
export const checkNeedCaptcha = <T>(phone: string) => newRequest.get<Ajax.Response<T>>(`/authority/user/login/needCode?phone=${phone}`)